export const TAX_REGIMES = [
  { code: "601", label: "601 - General de Ley Personas Morales", type: "moral" },
  { code: "603", label: "603 - Personas Morales con Fines no Lucrativos", type: "moral" },
  { code: "605", label: "605 - Sueldos y Salarios e Ingresos Asimilados a Salarios", type: "fisica" },
  { code: "606", label: "606 - Arrendamiento", type: "fisica" },
  { code: "607", label: "607 - Régimen de Enajenación o Adquisición de Bienes", type: "fisica" },
  { code: "608", label: "608 - Demás ingresos", type: "fisica" },
  { code: "610", label: "610 - Residentes en el Extranjero sin Establecimiento Permanente en México", type: "ambos" },
  { code: "611", label: "611 - Ingresos por Dividendos (socios y accionistas)", type: "fisica" },
  { code: "612", label: "612 - Personas Físicas con Actividades Empresariales y Profesionales", type: "fisica" },
  { code: "614", label: "614 - Ingresos por intereses", type: "fisica" },
  { code: "615", label: "615 - Régimen de los ingresos por obtención de premios", type: "fisica" },
  { code: "616", label: "616 - Sin obligaciones fiscales", type: "fisica" },
  { code: "620", label: "620 - Sociedades Cooperativas de Producción que difieren ingresos", type: "moral" },
  { code: "621", label: "621 - Incorporación Fiscal", type: "fisica" },
  { code: "622", label: "622 - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras", type: "ambos" },
  { code: "623", label: "623 - Opcional para Grupos de Sociedades", type: "moral" },
  { code: "624", label: "624 - Coordinados", type: "moral" },
  { code: "625", label: "625 - Actividades Empresariales con ingresos a través de Plataformas Tecnológicas", type: "fisica" },
  { code: "626", label: "626 - Régimen Simplificado de Confianza (RESICO)", type: "ambos" },
];
